module.exports = __webpack_public_path__ + "static/img/g1 (5).9cf2d56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hzppt/g1 (5).png
// module id = GRWO
// module chunks = 1